import {Component, Input} from '@angular/core';
import {Company} from "../../../interfaces/company.interface";

@Component({
  selector: 'app-industry-insights',
  templateUrl: './industry-insights.component.html',
  styleUrls: ['./industry-insights.component.scss']
})
export class IndustryInsightsComponent {

  @Input() reportSearch: any;
  @Input() company: Company;
  @Input() edit: boolean | undefined;

}
